import axios from 'axios'

import { CONNECTION_TIMEOUT } from '../../../config'
import { store } from '../../redux'

const { REACT_APP_API_GATEWAY, REACT_APP_BACKEND_BRAND } = process.env

export const validateIban = (iban: string): Promise<unknown> => {
  const dataStorageId = store.getState().storefront.id
  return axios
    .post(
      `${REACT_APP_API_GATEWAY}/iban/${REACT_APP_BACKEND_BRAND}/${dataStorageId}/validate`,
      { iban: iban.replace(/\s/g, '') },
      {
        timeout: CONNECTION_TIMEOUT,
        validateStatus: (statusCode) => statusCode === 200
      }
    )
    .then((result) => result)
    .catch((error) => error)
}
